import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDzu6KcFTyMHFwXPmtwMVzYwyFS9vXLE3k",
  authDomain: "trivia-quest-6ff6b.firebaseapp.com",
  databaseURL: "https://trivia-quest-6ff6b-default-rtdb.firebaseio.com",
  projectId: "trivia-quest-6ff6b",
  storageBucket: "trivia-quest-6ff6b.firebasestorage.app",
  messagingSenderId: "836210861128",
  appId: "1:836210861128:web:3e288d2a7e61ed9d91247d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app);
export default app;